import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the CSI assessment wizard (CSIAssessmentForm).
// Mirrors that layout: the node stepper card, a few question + slider blocks,
// and the nav buttons. Renders inner content only (no page wrapper), matching
// the form. Matches the app's other page skeletons instead of a spinner.
export default function CSIAssessmentSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div>
                {/* stepper card — mobile: current category name above nodes (no
                    per-node labels); desktop: labels under each node. Mirrors StepProgress. */}
                <div className={`${cardCls} p-4 md:p-5 mb-5`}>
                    <div className="md:hidden mb-3">
                        <Skeleton width={140} height={14} />
                    </div>
                    <div className="grid" style={{ gridTemplateColumns: "repeat(6,minmax(0,1fr))" }}>
                        {[0, 1, 2, 3, 4, 5].map(i => (
                            <div key={i} className="flex flex-col items-center">
                                <Skeleton circle width={30} height={30} />
                                <span className="hidden md:block mt-2">
                                    <Skeleton width={62} height={12} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* question + slider blocks */}
                <div className="space-y-6">
                    {[0, 1, 2, 3].map(i => (
                        <div key={i}>
                            <Skeleton width="65%" height={14} className="mb-3" />
                            <div className="flex items-center gap-3 sm:gap-4">
                                <div className="flex-1">
                                    <Skeleton height={8} borderRadius={999} />
                                    <div className="flex justify-between mt-1.5">
                                        <Skeleton width={92} height={11} />
                                        {/* old <Skeleton width={48} height={11} /> (the slider has end labels only now) */}
                                        <Skeleton width={80} height={11} />
                                    </div>
                                </div>
                                <Skeleton width={48} height={34} borderRadius={10} />
                            </div>
                        </div>
                    ))}
                </div>

                {/* nav buttons */}
                <div className="flex items-center justify-between mt-8">
                    <Skeleton width={92} height={42} borderRadius={12} />
                    <Skeleton width={150} height={42} borderRadius={12} />
                </div>
            </div>
        </SkeletonTheme>
    );
}
